const darkTheme = {
  isDark: true,
  grayscale: {
    '100': '249, 249, 249',
    '200': '207, 207, 207',
    neutral: '186, 186, 186',
    '400': '74, 74, 74',
  },
  background: {
    header: '44, 44, 44',
    modal: '34, 34, 34',
    high: '13, 13, 13',
    low: '27, 27, 27 ',
    doubtCard: '57, 57, 57',
  },
  primary: {
    100: '153, 61, 0',
    200: '204, 82, 0',
    300: '255, 102, 0',
    base: '255, 133, 51',
    500: '255, 163, 102',
    600: '255, 194, 153',
    700: '255, 224, 204',
  },
  component: {
    background: '34, 34, 34',
    accent: '51, 51, 51',
  },
  excerpt: {
    high: '34, 34, 34',
    primary: '249, 249, 249',
  },
  blueHighlight: {
    100: '0, 74, 183',
    200: '0, 92, 205',
    300: '0, 111, 228',
    base: '56, 134, 255',
    500: '84, 152, 255',
    600: '139, 194, 255',
    700: '168, 212, 255',
  },
  blue: {
    100: '4, 57, 82',
    200: '5, 81, 117',
    300: '7, 105, 152',
    base: '28, 137, 198',
    500: '50, 183, 246',
    600: '128, 210, 250',
    700: '182, 229, 252',
  },
  green: {
    100: '11, 109, 102',
    200: '15, 156, 145',
    300: '20, 203, 188',
    base: '127, 209, 203',
    500: '161, 221, 216',
    600: '199, 235, 232',
    700: '236, 248, 247',
  },
  greenProgress: {
    100: '0, 117, 0',
    200: '0, 139, 0',
    300: '0, 183, 0',
    base: '8, 221, 14',
    500: '36, 229, 30',
    600: '77, 253, 60',
    700: '107, 250, 86',
  },
  greenSuccess: {
    100: '0, 92, 58',
    200: '0, 133, 95',
    300: '0, 177, 135',
    base: '67, 222, 177',
    500: '96, 245, 199',
    600: '121, 255, 222',
    700: '163, 255, 232',
  },
  purple: {
    100: '82, 69, 151',
    200: '90, 76, 166',
    300: '99, 86, 183',
    base: '109, 92, 201',
    500: '169, 159, 223',
    600: '186, 178, 230',
    700: '204, 198, 236',
  },
  red: {
    100: '94, 44, 38',
    200: '141, 65, 58',
    300: '188, 87, 77',
    base: '235, 109, 96',
    500: '242, 161, 153',
    600: '248, 202, 198',
    700: '252, 232, 229',
  },
}

const lightTheme = {
  isDark: false,
  grayscale: {
    '100': '34, 34, 34',
    '200': '89, 89, 89',
    neutral: '128, 128, 128',
    '400': '227, 227, 227',
  },
  background: {
    header: '255, 255, 255',
    modal: '255, 255, 255',
    high: '255, 255, 255',
    low: '249, 249, 249',
    doubtCard: '249, 249, 249',
  },
  primary: {
    100: '102, 41, 0',
    200: '125, 50, 0',
    300: '178, 71, 0',
    base: '255, 102, 0',
    500: '255, 122, 34',
    600: '255, 175, 128',
    700: '255, 219, 197',
  },
  component: {
    background: '255, 255, 255',
    accent: '217, 217, 217',
  },
  excerpt: {
    high: '249, 249, 249',
    primary: '26, 26, 26',
  },
  blueHighlight: {
    100: '0, 54, 175',
    200: '0, 71, 198',
    300: '0, 89, 221',
    base: '0, 117, 255',
    500: '56, 134, 255',
    600: '114, 169, 255',
    700: '168, 212, 255',
  },
  blue: {
    100: '1, 17, 17',
    200: '2, 40, 57',
    300: '4, 57, 82',
    base: '5, 81, 117',
    500: '7, 105, 152',
    600: '8, 137, 198',
    700: '50, 183, 246',
  },
  green: {
    100: '4, 37, 35',
    200: '7, 76, 71',
    300: '11, 109, 102',
    base: '15, 156, 145',
    500: '20, 203, 188',
    600: '127, 209, 203',
    700: '161, 221, 216',
  },
  greenSuccess: {
    100: '0, 72, 40',
    200: '0, 112, 76',
    300: '0, 155, 115',
    base: '12, 193, 150',
    500: '31, 199, 156',
    600: '67, 222, 177',
    700: '96, 245, 199',
  },
  greenProgress: {
    100: '0, 74, 0',
    200: '0, 115, 0',
    300: '0, 159, 0',
    base: '7, 188, 12',
    500: '47, 203, 37',
    600: '79, 226, 63',
    700: '107, 250, 86',
  },
  purple: {
    100: '38, 32, 70',
    200: '57, 48, 106',
    300: '82, 69, 151',
    base: '90, 76, 166',
    500: '99, 83, 183',
    600: '109, 92, 201',
    700: '169, 159, 223',
  },
  red: {
    100: '37, 12, 10',
    200: '83, 28, 22',
    300: '148, 49, 38',
    base: '231, 76, 60',
    500: '240, 141, 130',
    600: '247, 191, 185',
    700: '251, 226, 224',
  },
}

export { darkTheme, lightTheme }
